export default __webpack_public_path__ + "static/media/flag-sri-lanka.3f30b7df.svg";